<script setup>
import FormButton from '../../Atoms/FormButton.vue'
import IconBase from '../../icon/IconBase.vue';
import IconInfo from '../../icon/IconInfo.vue';
import SelectLinkedSource from '../SelectLinkedSource.vue';
import GetRtmpSrtButtons from './GetRtmpSrtButtons.vue';
import Tooltip from '../../Atoms/Tooltip.vue'

const props = defineProps({
  stream: {
    type: Object,
    required: true,
    validator(v) {
      return Object.prototype.hasOwnProperty.call(v, '_id');
    }
  },
  streamAlive: {
    type: Boolean
  },
  isRtmpPullEnabled: {
    type: Boolean,
    default: false
  },
  rmptPullUrlProcessing: {
    type: Boolean,
    default: false
  },
  transcoderView: {
    type: Boolean,
    default: false
  },
  streamSourceType: {
    type: String
  },
  sourceTypes: {
    type: Object
  },
  selectedLinkedSource: {
    type: Object,
    default: null
  },
  sourceSet: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits({
  'request-url': () => true,
  'set-linked-source': () => true,
  'init-selected-source': () => true,
  'selected-source': () => true,
})

const requestUrl = (url) => emit('request-url', url);
const setLinkedSource = () => emit('set-linked-source')
const initSelectedSource =(source) => emit('init-selected-source', source);
const selectedSource = (source) => emit('selected-source', source);

</script>
<template>
  <!-- Dropdown for Linked Source -->
    <div class="w-full relative mt-3">
      <div v-show="stream.type === 'live' || stream.type === 'restream'" class="region">
        <div class="bg-surface-1 rounded-lg p-3">
          <div class="flex items-center mb-1 w-full">
            <label class="mb-0 text-sm text-surface-8" for="sourceSelect">Select Source</label>
            <Tooltip v-if="selectedLinkedSource && !selectedLinkedSource.enabled" content="Source is disabled">
              <icon-base class="mx-2 text-warning" fill="none">
                <icon-info />
              </icon-base>
            </Tooltip>
          </div>
          <SelectLinkedSource
            :class="{ 'ring-1 ring-warning rounded-md': selectedLinkedSource && !selectedLinkedSource.enabled }"
            :stream="stream" @selected-source="selectedSource" @init-linked-source="initSelectedSource" fullWidth
            show-alert />
          <FormButton class="w-full justify-center mt-3" size="sm" @click="setLinkedSource" :disabled="sourceSet">
            {{ sourceSet ? 'Source set' : 'Set as source' }}
          </FormButton>
        </div>

        <GetRtmpSrtButtons
          v-if="!transcoderView"
          @request-url="requestUrl"
          :stream="stream"
          :stream-alive="streamAlive"
          :is-rtmp-pull-enabled="isRtmpPullEnabled"
          :rmpt-pull-url-processing="rmptPullUrlProcessing"
          :stream-source-type="streamSourceType" :source-types="sourceTypes"
          class="!justify-start mt-3"
        />
      </div>
    </div>
</template>